// Asks the server which build is live (its main bundle hash), to compare with buildVersion().
// Resolves to null with no signal.
export async function latestVersion() {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 4000);
  try {
    const res = await fetch('/asset-manifest.json', { cache: 'no-store', signal: controller.signal });
    const main = (await res.json())?.files?.['main.js'] || '';
    return main.match(/main\.([a-f0-9]+)\.js/)?.[1] || null;
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}
